import {
  CREATE_AUTH_CONNECTION,
  GET_AUTH_CONNECTIONS,
  UPDATE_AUTH_CONNECTION,
  GET_REFERENCES,
  DELETE_AUTH_CONNECTION,
  GET_USER_VISIBLE_COLUMNS
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getAuthConnectionsStatus = state => state.status[getActionStatusName(GET_AUTH_CONNECTIONS)] || {};
export const createAuthConnectionStatus = state => state.status[getActionStatusName(CREATE_AUTH_CONNECTION)] || {};
export const updateAuthConnectionStatus = state => state.status[getActionStatusName(UPDATE_AUTH_CONNECTION)] || {};
export const getReferencesStatus = state => state.status[getActionStatusName(GET_REFERENCES)] || {};
export const deleteAuthConnectionStatus = state => state.status[getActionStatusName(DELETE_AUTH_CONNECTION)] || {};
export const getUserVisibleColumnsStatus = state => state.status[getActionStatusName(GET_USER_VISIBLE_COLUMNS)] || {};
